import React from 'react';
import { Box, Grid, LinearProgress, Tooltip, Typography } from '@mui/material';
import { KpiTile, Section, formatAed, formatBytes, formatCount, sumKnown } from './common';

/** Value flowing through the platform and cost to serve (design §3.9). */
const ValueCostPanel = ({ centers, source, storageSource }) => {
  const invoiced = sumKnown(centers, 'gmvInvoiced');
  const collected = sumKnown(centers, 'gmvCollected');
  const tokens = sumKnown(centers, 'aiTokens');
  const topStorage = centers.filter((c) => c.storageBytes > 0).sort((a, b) => b.storageBytes - a.storageBytes).slice(0, 5);
  const maxBytes = topStorage[0]?.storageBytes || 1;

  return (
    <Section title="Value & cost" source={source}>
      <Grid container spacing={1.5}>
        <Grid item xs={12} md={7}>
          <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4}>
          <KpiTile testId="value-invoiced" label="Invoiced through Thaklis" value={formatAed(invoiced)}
            sub="by all centers this period" tooltip="What our customers bill through us — not Thaklis revenue" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KpiTile label="Collected through Thaklis" value={formatAed(collected)}
            sub={invoiced ? `${Math.round(((collected || 0) / invoiced) * 100)}% of invoiced` : null} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KpiTile testId="value-ai-tokens" label="AI tokens used" value={formatCount(tokens)}
            sub="extraction + assistant" tooltip="AED cost needs the AI model price table (design §8.2)" />
        </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={5}>
          <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', mb: 0.75 }}>
            Top storage {storageSource === 'live' ? '(live snapshot)' : ''}
          </Typography>
          {topStorage.length === 0 && <Typography sx={{ fontSize: '0.8125rem', color: 'text.secondary' }}>No center has stored files yet.</Typography>}
          {topStorage.map((c) => (
            <Box key={c.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Tooltip title={c.name}>
                <Typography sx={{ fontSize: '0.75rem', width: 140, flexShrink: 0 }} noWrap>{c.name}</Typography>
              </Tooltip>
              <LinearProgress variant="determinate" value={(c.storageBytes / maxBytes) * 100} sx={{ flex: 1, height: 6, borderRadius: 3 }} />
              <Typography sx={{ fontSize: '0.75rem', width: 72, flexShrink: 0, textAlign: 'right' }}>{formatBytes(c.storageBytes)}</Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Section>
  );
};

export default ValueCostPanel;
